export enum IntakeManagerDocumentRoute {
  INDEX = "index",
  TRIAGE = "triage",
}
